module.exports = __webpack_public_path__ + "img/00.cd066b75.png";